import { Pill } from "components/ui/Pill/Pill";
import { getHealthlinkStatusColors } from "features/healthlink/utils/healthlinkStatusTone";
import { getLabOrderStatusConfig } from "features/labOrders/utils/labOrderStatus";

// The order's status as one label a GP can act on, in the app's shared Pill — the same
// primitive the documents table, the referral table and the CDM submission section use.
// The text is always rendered: colour alone must never carry the meaning.
export const LabOrderStatusPill = ({ order, size = "normal" }) => {
  const config = getLabOrderStatusConfig(order);

  return (
    <Pill {...getHealthlinkStatusColors(config.tone)} size={size}>
      {config.label}
    </Pill>
  );
};
